import React, { FC } from 'react';
import { NextPageContext } from 'next';

interface Props {
  children: any;
  serverContext: {
    req: NextPageContext['req'];
    res: NextPageContext['res'];
  };
}

const initialValue = {
  children: undefined,
  serverContext: {
    req: undefined,
    res: undefined,
  },
};

const ServerContext = React.createContext<Props>(initialValue);

// eslint-disable-next-line
const ServerContextProvider: FC<Props> = React.memo(({ children, serverContext }) => (
  // @ts-expect-error
  <ServerContext.Provider value={{ serverContext }}>{children}</ServerContext.Provider>
));

ServerContextProvider.displayName = 'ServerContextProvider';

function useServerContext() {
  const context = React.useContext(ServerContext);
  return context;
}

export { ServerContextProvider };

export default useServerContext;
